import Service from "@/services/Service";

export class AuthenticationService extends Service {
  static async signInByPassword (
    // eslint-disable-next-line no-unused-vars
    login,
    // eslint-disable-next-line no-unused-vars
    password
  ) {
    // do nothing
    /* try {
      await console.log("Authentication POST", login, password);
      console.log(this.api);
    } catch (error) {
      throw error;
    } */
  }

  static async whoAmI () {
    // do nothing
    /* try {
      await console.log("Authentication GET whoAmI");
    } catch (error) {
      throw error;
    } */
  }

  static async refreshToken (
    // eslint-disable-next-line no-unused-vars
    token
  ) {
    // do nothing
    /* try {
      await console.log("Authentication POST refresh tokens", token);
    } catch (error) {
      throw error;
    } */
  }
}
